import { createSelector } from 'reselect';
import { useAppSelector } from '@/store/hooks';
export const releaseNotesSelector = ({ releaseNotes }) => releaseNotes;
export const releaseNotesFilterTermSelector = createSelector(releaseNotesSelector, ({ filterTerm }) => filterTerm);
export const releaseNotesItemsSelector = createSelector(releaseNotesSelector, ({ items }) => items);
export const useReleaseNotesFilterTermSelector = () => useAppSelector(releaseNotesFilterTermSelector);
export const useReleaseNotesItemsSelector = () => useAppSelector(releaseNotesItemsSelector);
